import React from 'react';
import { useParams } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { useMyRecentTickets } from 'selectors/ticket-selectors';
import AppBar from 'components/app-bar/app-bar';
import Section from 'components/content/section';

import TicketCard from '../waitlist/ticket-card/ticket-card';
import OfficeHoursMenu from '../menu/office-hours-menu';

export default function ActivityPage() {
  const params = useParams();
  const courseId = Number(params.courseId);
  const tickets = useMyRecentTickets(courseId);

  return (
    <AppBar
      title="Latest activity"
      menu={<OfficeHoursMenu courseId={courseId} />}
    >
      <Box clone p={2}>
        <Paper>
          <Section title="Latest activity">
            {tickets.map((ticket) => (
              <TicketCard key={ticket.id} ticket={ticket} />
            ))}

            {tickets.length === 0 && (
              <Typography paragraph>
                There have been no recent office hours interactions.
              </Typography>
            )}
          </Section>
        </Paper>
      </Box>
    </AppBar>
  );
}
